import { graphql } from '~/graphql/generated/gql';

export const skillFragment = graphql(`
  fragment SkillFields on Skill {
    id
    name
    description
    slug
    iconFile {
      ...PublicFileFields
    }
  }
`);

export const badgeMetaFragment = graphql(`
  fragment BadgeMetaFields on BadgeMeta {
    description
    disclaimer
  }
`);

export const adminBadgeFragment = graphql(`
  fragment AdminBadgeFields on AdminBadge {
    id
    name
    tier
    slug
    iconFileId
    coverImageId
    premiumBadgeFileId
    partnerId
    iconFile {
      ...AdminContentFileFields
    }
    coverImage {
      ...AdminContentFileFields
    }
    premiumBadgeFile {
      ...AdminContentFileFields
    }
    learningAssetCollections: authoredLearningAssetCollections {
      id
      name
      slug
    }
    meta {
      ...BadgeMetaFields
    }
    partner {
      ...AdminPartnerReferenceFields
    }
    publishedAt
  }
`);

export const adminBadgeListFragment = graphql(`
  fragment AdminBadgeListFields on AdminBadge {
    id
    name
    tier
    slug
    partner {
      ...AdminPartnerReferenceFields
    }
    createdAt
    learningAssetCollections: authoredLearningAssetCollections {
      id
      name
      publishedAt
    }
    publishedAt
  }
`);

export const adminSkills = graphql(`
  query adminSkills($page: Int!, $first: Int!, $filters: AdminSkillFilters) {
    skillsList(page: $page, first: $first, filters: $filters) {
      data {
        ...AdminSkillFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const adminBadges = graphql(`
  query adminBadges($page: Int!, $first: Int!, $filters: AdminBadgeFilters) {
    badgesList(page: $page, first: $first, filters: $filters) {
      data {
        ...AdminBadgeListFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const adminBadgeDetail = graphql(`
  query adminBadgeDetail($filters: AdminBadgeFilters) {
    badgesList(page: 1, first: 1, filters: $filters) {
      data {
        ...AdminBadgeFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const createBadge = graphql(`
  mutation createBadge($input: CreateBadgeInput!) { 
    createBadge(input: $input) {
      badge {
        ...AdminBadgeFields
      }
    }
  }
`);

export const updateBadge = graphql(`
  mutation updateBadge($input: UpdateBadgeInput!) {
    updateBadge(input: $input) {
      badge {
        ...AdminBadgeFields
      }
    }
  }
`);

export const deleteBadge = graphql(`
  mutation deleteBadge($input: DeleteBadgeInput!) {
    deleteBadge(input: $input) {
      success
    }
  }
`);

export const publishBadge = graphql(`
  mutation publishBadge($input: PublishBadgeInput!) {
    publishBadge(input: $input) {
      badge {
        ...AdminBadgeFields
      }
    }
  }
`);

export const unpublishBadge = graphql(`
  mutation unpublishBadge($input: UnpublishBadgeInput!) {
    unpublishBadge(input: $input) {
      badge {
        ...AdminBadgeFields
      }
    }
  }
`);
